import appIcon from 'assets/app-icon.png';
import React from 'react';
import { QRCode } from 'react-qrcode-logo';
import { DOWNLOAD_APP_URL } from 'utils/appStore';

interface SignUpQrCodeProps {
  size?: number;
}

// Level H error correction keeps the code scannable with the logo covering the centre.
const LOGO_RATIO = 0.2;

// QR code printed on the login screens; scanning it opens the device's app store (see DownloadApp).
const SignUpQrCode: React.FC<SignUpQrCodeProps> = ({ size = 154 }) => (
  <div role="img" aria-label="QR code to download the Exos app">
    <QRCode
      value={DOWNLOAD_APP_URL}
      size={size}
      quietZone={0}
      qrStyle="fluid"
      ecLevel="H"
      eyeRadius={size * 0.05}
      logoImage={appIcon}
      logoWidth={size * LOGO_RATIO}
      logoHeight={size * LOGO_RATIO}
      removeQrCodeBehindLogo
    />
  </div>
);

export default SignUpQrCode;
